export default __webpack_public_path__ + "static/slide-01-46210c9d67dae4c37880028f52d5f5d9.png";